import { Helmet } from 'react-helmet-async';

/**
 * Composant SEO réutilisable
 * Usage : <SEO title="..." description="..." canonical="/..." noindex />
 */
const SEO = ({
  title,
  description,
  canonical,
  noindex = false,
  og = {},
}) => {
  const BASE_URL = 'https://aerotrick.com';
  const fullCanonical = canonical ? `${BASE_URL}${canonical}` : BASE_URL;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:title" content={og.title || title} />
      <meta property="og:description" content={og.description || description} />
      <meta property="og:url" content={og.url || fullCanonical} />
      <meta property="og:type" content={og.type || 'website'} />
      <meta property="og:site_name" content="AeroTrick" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={og.title || title} />
      <meta name="twitter:description" content={og.description || description} />
    </Helmet>
  );
};

export default SEO;